import AfterRepair from './after_repair.png';
import Apartments from './apartments.png';
import Offices from './offices.png';

export const cleaningImgs = {
  AfterRepair,
  Apartments,
  Offices,
};
